module.exports = __webpack_public_path__ + "static/media/05.5d151a48.png";